import { SyntheticEvent, useState } from "react";

const usePopover = ({ trigger }: {
	trigger: "click" | "hover";
}) => {

	const [ anchorEl, setAnchorEl ] = useState<HTMLElement | null>(null);

	const open = Boolean(anchorEl);

	return {
		popoverProps: {
			sx: {
				pointerEvents: trigger === "hover" ? "none" : "inherit",
			},
			open: open,
			anchorEl: anchorEl,
			anchorOrigin: {
				vertical: "bottom" as const,
				horizontal: "left" as const,
			},
			transformOrigin: {
				vertical: "top" as const,
				horizontal: "left" as const,
			},
			onClose: () => {
				setAnchorEl(null);
			},
			disableRestoreFocus: true,
		},
		onPopoverOpen: (event: SyntheticEvent) => {
			setAnchorEl(event.currentTarget as HTMLElement);
		},
		onPopoverClose: () => {
			setAnchorEl(null);
		},
	};
};

export default usePopover;
